module.exports = __webpack_public_path__ + "static/thlive-resource-tile-f54b2257e3f11b77ac81cdc13521b3f5.png";